import api from "../../../api";

export interface ISubtitle {
  start: { total_milliseconds: number };
  end: { total_milliseconds: number };
  text: string;
}

export interface ITextSourceResponse {
  done: boolean;
  progress: number;
  response: {
    duration: { total_milliseconds: number };
    subtitles: ISubtitle[];
  };
}

export interface ITextSourceRepository {
  getASRText: (fileId: string) => Promise<ITextSourceResponse>;
}

class TextSourceRepository implements ITextSourceRepository {
  public getASRText = async (fileId: string) => {
    const { data } = await api.getTextSource(fileId);
    return data;
  };
}

export default TextSourceRepository;
